import { Action } from 'redux';
import { ContractStageTypeState, ContractStageTypeUnloadState } from '../../states/ContractStageTypes.State';
import {
  CONTRACTSTAGETYPE_GET_ALL_REQUEST,
  CONTRACTSTAGETYPE_GET_ALL_SUCCESS,
  CONTRACTSTAGETYPE_GET_ALL_FAILURE,
  CONTRACTSTAGETYPE_GET_BY_ID_REQUEST,
  CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS,
  CONTRACTSTAGETYPE_GET_BY_ID_FAILURE,
} from '../../actions/ContractStageType.Actions';

export default function ContractStageTypesReducer(
  state: ContractStageTypeState | undefined,
  action: Action
): ContractStageTypeState {
  const current = (state as any) ?? ContractStageTypeUnloadState;
  const a: any = action;
  switch (a.type) {
    case CONTRACTSTAGETYPE_GET_ALL_REQUEST:
      return { ...current, isLoadingAll: true, successLoadingAll: undefined, failOnLoadingAll: false, error: undefined } as any;
    case CONTRACTSTAGETYPE_GET_ALL_SUCCESS:
      return { ...current, isLoadingAll: false, successLoadingAll: true, failOnLoadingAll: false, list: a.StageTypes, error: undefined } as any;
    case CONTRACTSTAGETYPE_GET_ALL_FAILURE:
      return { ...current, isLoadingAll: false, successLoadingAll: false, failOnLoadingAll: true, error: a.error } as any;

    case CONTRACTSTAGETYPE_GET_BY_ID_REQUEST:
      return { ...current, isLoadingOne: true, isLoadingOneSuccess: undefined, FailGettingOne: false, error: undefined } as any;
    case CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS: {
      const updatedList = (current.list || []).filter((st: any) => st.id !== a.StageType?.id).concat(a.StageType ? [a.StageType] : []);
      return { ...current, isLoadingOne: false, isLoadingOneSuccess: true, FailGettingOne: false, list: updatedList, error: undefined } as any;
    }
    case CONTRACTSTAGETYPE_GET_BY_ID_FAILURE:
      return { ...current, isLoadingOne: false, isLoadingOneSuccess: false, FailGettingOne: true, error: a.error } as any;

    default:
      return current as any;
  }
}
